import EventArea from "@/components/publicWebsite/events/eventArea";
import PageHeader from "@/components/publicWebsite/common/pageHeader";
import { eventData } from "@/db/blogPostsData";

export default function Blog() { 
    
  
  return (
    <>
      <PageHeader title="Events"  image="/images/banners/c15.png" />
      <div className="pb-120 border-bottom"></div>
      <EventArea
        data={eventData}
        className="bg-f3f3f3 border-bottom-0"
      />
    
    </>
  );
}; 
